import React, { useState, useEffect, useCallback, useRef } from 'react'
// import { Modal } from '@mui/material'
import { Modal } from 'components'

import { InfoOutlined } from '@mui/icons-material'
import ReviewRow from './ReviewRow'
import styles from './styles'
import ReviewAnalysis from './ReviewAnalysis'

function ReviewTable(props) {
  const { reviews, reloadData, checkType } = props
  
  const classes = styles()
  
  const [modal, setModal] = useState(false)
  const [clickedUUID, setClickedUUID] = useState(null)
  const [review, setReview] = useState(null)
  const hasChanged = useRef(false)

  const handleCloseModal = () => {
    setModal(false)
    if (hasChanged.current) {
      hasChanged.current = false
      reloadData()
    }
  }

  const handleDataChanged = () => {
    hasChanged.current = true
  }
  
  const handleOpenModal = (event) => {
    const uuid = event.target.id
    setClickedUUID(uuid)
  }
  
  const getReview = useCallback((review_id) => {
    return reviews.find((rev) => review_id === rev.uuid)
  }, [reviews])
  
  useEffect(() => {
    if (clickedUUID) 
      setReview(getReview(clickedUUID))
  }, [clickedUUID, getReview])
  
  useEffect(() => {
    if (review) 
      setModal(true)
  }, [review])
  
  return (
    <React.Fragment>
      {
        reviews?.length > 0 ? (
          <table className={classes.dataTable}>
            <thead>
              <tr>
                <th>
                  Data de derivação para revisão
                </th>
                <th>
                  nome
                </th>
                <th>
                  cpf
                </th>
                <th>
                  Tema
                </th>
                <th>
                  Ponto de atenção
                </th>
                <th className='middle-col'>
                  Revisor
                </th>
                <th className='middle-col'>
                  Data da Revisão
                </th>
                <th className='middle-col'>
                  Status da revisão
                </th>
                <th className='middle-col'>
                  Conteúdo
                </th>
              </tr>
            </thead>
            <tbody>
              {
                reviews?.map(rev => <ReviewRow key={rev.uuid} onClick={handleOpenModal} review={rev} checkType={checkType} />)
              }
            </tbody>
          </table>
        ) : (
          <div className={classes.noData}>
            <span>
              <InfoOutlined fontSize='inherit' />
            </span>
            <span>Nenhum registro encontrado</span>
          </div>
        )
      }
      {clickedUUID && (
        <Modal
          open={modal}
          onClose={handleCloseModal}
          title={`Revisão Manual de ${checkType === false ? 'Background Check' : 'Análise de Crédito'}`}
        >
          <ReviewAnalysis checkType={checkType} reviewData={review} onDataChanged={handleDataChanged} />
        </Modal>
      )}
    </React.Fragment>
  )
}
export default ReviewTable
